import { z } from "zod";
import { PARTICIPANT_TYPES } from "@/isomorphic/constants/call-data-consts";

/**
 * Call Participant Schema (Isomorphic - camelCase)
 * Represents who participated in a call
 */
export const CallParticipantSchema = z.object({
  id: z.string().uuid(),
  callAttemptId: z.string().uuid(),

  // Type de participant
  participantType: z.enum(PARTICIPANT_TYPES),

  // Identification
  identifiedAs: z.string().nullable(),

  // Métadonnées
  notes: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).default({}),

  createdAt: z.date(),
  updatedAt: z.date(),
});

export type CallParticipant = z.infer<typeof CallParticipantSchema>;
